import { InfoOption } from '../components/info/info.component';
import { FormControlOption } from '../definition/interface/formControlOption.interface';

export const knowledgeOptions = [
  {
    value: 'YES',
    label: 'Vrai',
  },
  {
    value: 'NO',
    label: 'Faux',
  },
  {
    value: 'UNKNOWN',
    label: 'Je ne sais pas',
  },
];

export const childrenOptions = [
  {
    label: '0',
    value: '0',
  },
  {
    label: '1',
    value: '1',
  },
  {
    label: '2',
    value: '2',
  },
  {
    label: '3',
    value: '3',
  },
  {
    label: '4',
    value: '4',
  },
  {
    label: '+4',
    value: 'FIVE_OR_MORE',
  },
];
export const patrimonyValueOptions = [
  {
    value: 'LOWER_THAN_100K',
    label: 'Inférieur à 100k€',
    suffix: { title: 'A' },
  },
  {
    value: 'BETWEEN_100K_AND_300K',
    label: 'Entre 100k et 300k€',
    suffix: { title: 'B' },
  },
  {
    value: 'BETWEEN_300K_AND_500K',
    label: 'Entre 300k et 500k€',
    suffix: { title: 'C' },
  },
  {
    value: 'BETWEEN_500K_AND_1M',
    label: 'Entre 500k€ et 1M€',
    suffix: { title: 'D' },
  },
  {
    value: 'GREATER_THAN_1M',
    label: 'Supérieur à 1M€',
    suffix: { title: 'E' },
  },
];
export const investmentGoalsOptions = [
  {
    label: "Faire une opération d'épargne",
    value: 'GENERATE_WEALTH',
  },
  {
    label: 'Financer un projet futur',
    value: 'PREPARE_FUTUR',
  },
  {
    label: 'Transmettre un capital (préparer sa succession)',
    value: 'PASS_ON_TO_RELATIVES',
  },
  {
    label: 'Disposer de revenus complémentaires immédiats',
    value: 'GENERATE_INCOME',
  },
  {
    label: 'Disposer de revenus complémentaires futurs (retraite, ...)',
    value: 'PREPARE_RETIREMENT',
  },
  {
    label: 'Gestion de trésorerie',
    value: 'TREASURY_MANAGEMENT',
  },
  {
    label:
      'Utiliser le contrat comme un instrument de garantie (nantissement,...)',
    value: 'GENERATE_GARANTY',
  },
  {
    label: 'Autre',
    value: 'OTHER',
  },
];

export const investmentDurationOptions = [
  { value: 'MINUS_TWO', label: 'Moins de 2 ans', suffix: { title: 'A' } },
  { value: 'TWO_FIVE', label: 'De 2 à 5 ans', suffix: { title: 'B' } },
  { value: 'FIVE_EIGHT', label: 'De 5 à 8 ans', suffix: { title: 'C' } },
  {
    value: 'MORE_THAN_EIGHT',
    label: 'Plus de 8 ans',
    suffix: { title: 'D' },
  },
];
export const investmentDurationOptions2 = [
  { value: 'MINUS_FIVE', label: 'Moins de 5 ans', suffix: { title: 'A' } },
  { value: 'FIVE_EIGHT', label: 'De 5 à 8 ans', suffix: { title: 'B' } },
  { value: 'EIGHT_TEN', label: 'De 8 à 10 ans', suffix: { title: 'C' } },
  {
    value: 'TEN_TWELVE',
    label: 'De 10 à 12 ans',
    suffix: { title: 'D' },
  },

  {
    value: 'TWELVE_FIFTEEN',
    label: 'De 12 à 15 ans',
    suffix: { title: 'E' },
  },
  {
    value: 'FIFTEEN_TWENTY',
    label: 'De 15 à 20 ans',
    suffix: { title: 'F' },
  },
  {
    value: 'MORE_THAN_TWENTY',
    label: 'Plus de 20 ans',
    suffix: { title: 'G' },
  },
];
export const investmentDurationOptions3 = [
  { value: 'MINUS_FIVE', label: 'Moins de 5 ans', suffix: { title: 'A' } },
  { value: 'FIVE_EIGHT', label: 'De 5 à 8 ans', suffix: { title: 'B' } },
  { value: 'EIGHT_TEN', label: 'De 8 à 10 ans', suffix: { title: 'C' } },
];
export const repartitionTypeOptions = [
  { value: 'PERCENTAGE', label: 'Pourcentage', suffix: { title: 'A' } },
  { value: 'AMOUNT', label: 'Montant', suffix: { title: 'B' } },
];
export const perTnsSalarieOptions = [
  {
    value: 'SALARIE',
    label: 'Tout public  (déductibilité en tant que salarié)',
    suffix: { title: 'A' },
  },
  {
    value: 'TNS',
    label: 'TNS (déductibilité en tant que TNS)',
    suffix: { title: 'B' },
  },
];
export const riskToleranceOptions = [
  {
    value: 'HIGH_RISK_TOLERANCE',
    label: 'Placement avec un risque élevé',
    suffix: { title: 'A', color: '#00b0f0', borderColor: '#00b0f0' },
  },
  {
    value: 'MEDIUM_RISK_TOLERANCE',
    label: 'Placement avec un risque modéré',
    suffix: { title: 'B', color: '#00b050', borderColor: '#00b050' },
  },
  {
    value: 'LOW_RISK_TOLERANCE',
    label: 'Placement avec un risque faible',
    suffix: { title: 'C', color: '#c00000', borderColor: '#c00000' },
  },
];

export const limitOptions = [
  {
    value: 'PERCENT_5',
    label: '5%',
  },
  {
    value: 'PERCENT_10',
    label: '10%',
  },
  {
    value: 'PERCENT_15',
    label: '15%',
  },
  {
    value: 'PERCENT_20',
    label: '20%',
  },
  {
    value: 'PERCENT_30',
    label: '30%',
  },
  {
    value: 'CUSTOM',
    label: 'Seuil libre',
  },
];

export const infoOption: InfoOption = {
  icon: 'warning',
  backgroundColor: '#fae4e4',
  iconColor: '#a00d0d',
  textColor: '#a00d0d',
};
export const getPoliticalRelationshipOptions = [
  {
    value: 'SPOUSE',
    label: 'Conjoint',
  },
  {
    value: 'CHILD',
    label: 'Enfant',
  },
  {
    value: 'PARENT',
    label: 'Parent',
  },
  {
    value: 'SIBLING',
    label: 'Frère/sœur',
  },
  {
    value: 'FAMILY',
    label: 'Autre membre de la famille',
  },
  {
    value: 'OTHER',
    label: 'Autre',
  },
];
export const getPoliticalFunctionOptions = [
  {
    value: 'CHEF_ETAT',
    label:
      "Chef d'État, de gouvernement, membre d'un gourvernement national ou de la Commission europenne",
  },
  {
    value: 'MEMB_ASS',
    label:
      "Membre d'une assemblée parlementaire / nationale, du Parlement européen",
  },
  {
    value: 'MEMB_COUR_SUP',
    label:
      "Membre d'une cour suprême, constitutionnelle ou d'une haute jurvalueiction",
  },
  { value: 'MEMB_COUR_COMPT', label: "Membre d'une cour des comptes" },
  {
    value: 'DIRIG_ORG_BANK_C',
    label: "Dirigeant ou membre de l'organe de direction d'une banque centrale",
  },
  {
    value: 'AMBA',
    label:
      "Ambassadeur, chargé d'affaires, consul général ou consul de carrière",
  },
  {
    value: 'OFF_GEN_SUP',
    label:
      "Officier général ou officier supérieur assurant le commandement d'une armée",
  },
  {
    value: 'MEMB_ORG_ADM',
    label:
      "Membre d'un organe d'administration, de direction ou de surveillance d'une entreprise publique",
  },
  {
    value: 'DIRIG_INST_INTERN',
    label:
      "Dirigeant d'une institution internationale publique créée par un traité",
  },
];
export const getFundsInitialPaymentOptions = [
  {
    label: 'Épargne',
    value: 'SAVING',
  },
  {
    label: 'Gain au jeu',
    value: 'GAME_WINNING',
  },
  {
    label: 'Héritage',
    value: 'HERITAGE',
  },
  {
    label: 'Immobilier',
    value: 'SALES_OF_REALESTATE_ASSETS',
  },
  {
    label: 'Assurance vie',
    value: 'LIFE_INSURANCE',
  },
  {
    label: 'Crédit',
    value: 'CREDIT',
  },
  {
    label: 'Donation',
    value: 'DONATION',
  },
  {
    label: 'Mobilier',
    value: 'DISPOSAL_OF_MOVABLE_ASSETS',
  },
  {
    label: 'Réemploi',
    value: 'REUSE',
  },
  {
    label: 'Autre',
    value: 'OTHER',
  },
];
export const ownershipTypeScpiOptions: FormControlOption[] = [
  {
    value: 'PLEINE_PROPRIETE_CASH',
    label: 'En cash',
    suffix: 'A',
    svg: 'money1.svg',
  },
  {
    value: 'PLEINE_PROPRIETE_CREDIT',
    label: 'À crédit',
    suffix: 'B',
    svg: 'cashback1.svg',
  },

  {
    value: 'NU_PROPRIO',
    label: 'Nue-propriété',
    suffix: 'C',
    svg: 'money1.svg',
  },
  {
    value: 'USUFRUIT',
    label: 'Usufruit',
    suffix: 'D',
    svg: 'money1.svg',
  },
];
export const beneficiaryTypeOptions: FormControlOption[] = [
  {
    label: 'Clause standard',
    value: 'STANDARD',
    suffix: 'A',
    svg: 'standard-clause.svg',
  },
  {
    label: 'Clause libre',
    value: 'LIBRE',
    suffix: 'B',
    svg: 'free-clause.svg',
  },
  {
    label: 'Clause notariale',
    value: 'NOTARIALE',
    suffix: 'C',
    svg: 'notarial-clause.svg',
  },
];
export const beneficiaryTypeWithoutNotarialeOptions: FormControlOption[] = [
  {
    label: 'Clause standard',
    value: 'STANDARD',
    suffix: 'A',
    svg: 'standard-clause.svg',
  },
  {
    label: 'Clause libre',
    value: 'LIBRE',
    suffix: 'B',
    svg: 'free-clause.svg',
  },
];
export const riskLevelOptions = [
  {
    value: 'NO_RISK',
    label: 'Aucun risque - Perte en capital de 0%',
    suffix: { title: 'A' },
  },
  {
    value: 'LOW_RISK',
    label: 'Risque faible - Perte en capital de 10% maximum',
    suffix: { title: 'B' },
  },
  {
    value: 'MEDIUM_RISK',
    label: 'Risque moyen - Perte en capital de 20% maximum',
    suffix: { title: 'C' },
  },

  {
    value: 'HIGH_RISK',
    label: 'Risque élevé - Perte en capital > 20%',
    suffix: { title: 'D' },
  },
];
export const maximumLostPercentOptions = [
  {
    value: 'PERCENT_0',
    label: '0%',
    suffix: { title: 'A' },
  },
  {
    value: 'PERCENT_1_5',
    label: '1% à 5%',
    suffix: { title: 'B' },
  },
  {
    value: 'PERCENT_6_10',
    label: '6% à 10%',
    suffix: { title: 'C' },
  },
  {
    value: 'PERCENT_11_15',
    label: '11% à 15%',
    suffix: { title: 'D' },
  },
  {
    value: 'PERCENT_16_20',
    label: '16% à 20%',
    suffix: { title: 'E' },
  },
  {
    value: 'PERCENT_21_35',
    label: '21% à 35%',
    suffix: { title: 'F' },
  },
  {
    value: 'PERCENT_35_PLUS',
    label: '> à 35%',
    suffix: { title: 'G' },
  },
];
export const distributionAssetsOptions: FormControlOption[] = [
  {
    label: 'Actifs financiers',
    value: 'FINANCIAL_ASSETS',
  },

  {
    label: 'En liquidités',
    value: 'LIQUIDITY',
  },
  {
    label: 'En actifs professionnels',
    value: 'PROFESSIONAL_ASSETS',
  },
  {
    label: "En immobilier d'investissement",
    value: 'REAL_ESTATE_INVESTMENT',
  },
  {
    label: 'En immobilier de jouissance',
    value: 'REAL_ESTATE_PERSONAL',
  },
];
export const distributionAssetsIncomeOptions: FormControlOption[] = [
  {
    label: 'Salaires ou pensions',
    value: 'FINANCIAL_ASSETS',
  },

  {
    label: 'Revenus fonciers ou BIC',
    value: 'LIQUIDITY',
  },
  {
    label: 'Revenus mobiliers',
    value: 'PROFESSIONAL_ASSETS',
  },
];
export const userSocialRegimeOptions: FormControlOption[] = [
  {
    label: 'Sécurité sociale',
    value: 'SOCIAL_SECURITY',
  },

  {
    label: 'TNS',
    value: 'TNS',
  },
  {
    label: 'Agricole',
    value: 'AGRICULTURAL',
  },
];

export const nonESGInvestmentsOptions: FormControlOption[] = [
  // {
  //   value: "null",
  //   label: "Aucun",
  // },
  {
    value: 'BIODIVERSITY',
    label: 'La biodiversité',
  },
  {
    value: 'HUMAN_RIGHTS',
    label: "Le respect des droits de l'homme",
  },
  {
    value: 'WATER',
    label: "L'eau",
  },
  {
    value: 'ANTI_CORRUPTION_FIGHT',
    label: 'La lutte anti-corruption',
  },
  {
    value: 'SOCIAL',
    label: 'Le social',
  },
  {
    value: 'ENVIRONMENT',
    label: "L'environnement",
  },
  {
    value: 'ENERGETIC_PERFORMANCE',
    label: 'La performance énergétique',
  },
  {
    value: 'WASTE_TREATMENT',
    label: 'Le traitement des déchets',
  },
];
export const investmentsForbidenOptions: FormControlOption[] = [
  // {
  //   value: "null",
  //   label: "Aucune",
  // },
  {
    value: 'NUCLEAR',
    label: 'Nucléaire',
  },
  {
    value: 'ARMAMENT',
    label: 'Armement',
  },
  {
    value: 'TOBACCOS',
    label: 'Tabac',
  },
  {
    value: 'ALCOOL',
    label: 'Alcool',
  },
  {
    value: 'CHARBON_THERMIQUE',
    label: 'Charbon thermique',
  },
  {
    value: 'DIVERTISSEMENTS_POUR_ADULTES',
    label: 'Divertissements pour adultes',
  },
  {
    value: 'ENERGIES_FOSSILES',
    label: 'Energies fossiles',
  },
  {
    value: 'HUILE_DE_PALME',
    label: 'Huile de palme',
  },
  {
    value: 'JEUX_DE_HASARD',
    label: 'Jeux de hasard',
  },
  {
    value: 'PESTICIDES',
    label: 'Pesticides',
  },
  {
    value: 'RECHERCHE_SUR_LES_EMBRYONS_HUMAINS',
    label: 'Recherche sur les embryons humains',
  },
  {
    value: 'OPIOIDES',
    label: 'Opioïdes',
  },
  {
    value: 'PRISONS_PRIVEES',
    label: 'Prisons privées',
  },
  {
    value: 'PRODUCTION_OU_EXTRACTION_DE_MATERIELS_RADIOTACTIFS',
    label: 'Production ou extraction de matériels radioactifs',
  },
  {
    value: 'TRAFICS_ESPECES_ANIMALES_MENACEES',
    label: "Trafics d'espèces animales menacées",
  },
];

export const taxonomyOptions: FormControlOption[] = [
  { value: '0', label: '0 %' },
  { value: '25', label: '25 %' },
  { value: '50', label: '50 %' },
  { value: '75', label: '75 %' },
  { value: '100', label: '100 %' },
];
export const sustainabilityOptions: FormControlOption[] = [
  { value: '0', label: '0 %' },
  { value: '25', label: '25 %' },
  { value: '50', label: '50 %' },
  { value: '75', label: '75 %' },
  { value: '100', label: '100 %' },
];
export const investmentsOptions: FormControlOption[] = [
  // {
  //   value: "null",
  //   label: "Aucun",
  // },
  {
    value: 'ENVIRONMENTAL',
    label: 'Environnemental',
  },
  {
    value: 'SOCIAL',
    label: 'Social',
  },
  {
    value: 'GOVERNANCE',
    label: 'Gouvernance',
  },
];
export const crowdfundingNominatifPurOptions = [
  {
    value: 'ADMINISTRED',
    label: 'Administré (PEA/PME, compte titres)',
    suffix: { title: 'A' },
  },
  { value: 'PUR', label: 'Pur (en direct)', suffix: { title: 'B' } },
];
export const crowdfundingNominatifAdministredOptions = [
  { value: 'DIRECT', label: 'Direct', suffix: { title: 'A' } },
  { value: 'COMPTE_TITRE', label: 'Compte Titres', suffix: { title: 'B' } },
  { value: 'PEA_PME', label: 'PEA PME', suffix: { title: 'C' } },
];
export const crowdfundingInsightOptions = [
  { value: 'PART_A', label: 'Part A (capitalisé)', suffix: { title: 'A' } },
  { value: 'PART_B', label: 'Part B (distributive)', suffix: { title: 'B' } },
];
export const nominatifPurOptions = [
  {
    value: 'ADMINISTRED',
    label: 'Administré (PEA/PME, compte titres)',
    suffix: { title: 'A' },
  },
  { value: 'PUR', label: 'Pur (en direct)', suffix: { title: 'B' } },
];
export const fcpiDeliveryModeOptions = [
  {
    value: 'NOMINATIF_PUR',
    label: 'En nominatif pur',
    suffix: { title: 'A' },
  },
  {
    value: 'COMPTE_TITRES',
    label: 'Compte titres',
    suffix: { title: 'B' },
  },
];
export const nominatifAdministredOptions = [
  { value: 'DIRECT', label: 'Direct', suffix: { title: 'A' } },
  { value: 'COMPTE_TITRE', label: 'Compte Titres', suffix: { title: 'B' } },
  { value: 'PEA_PME', label: 'PEA PME', suffix: { title: 'C' } },
];
export const insightOptions = [
  { value: 'PART_A', label: 'Part A (capitalisé)', suffix: { title: 'A' } },
  { value: 'PART_B', label: 'Part B (distributive)', suffix: { title: 'B' } },
];
export const knowledgeFinancialAssetsOptions = [
  {
    value: 'VERY_LOW',
    label: 'Très faible',
    suffix: { title: 'A' },
  },
  {
    value: 'LOW',
    label: 'Faible',
    suffix: { title: 'B' },
  },
  {
    value: 'MEDIUM',
    label: 'Moyen',
    suffix: { title: 'C' },
  },
  {
    value: 'HIGH',
    label: 'Elevé',
    suffix: { title: 'D' },
  },
];
export const paymentPrimesOptions = [
  {
    value: 'COMPTE_ASSURE',
    label: "Compte de l'assuré (non joint)",
    suffix: { title: 'A' },
  },
  {
    value: 'COMPTE_JOINT_ASSURE',
    label: "Compte joint de l'assuré",
    suffix: { title: 'B' },
  },
  {
    value: 'COMPTE_INDIVIS',
    label: 'Compte indivis',
    suffix: { title: 'C' },
  },
];
export const swisslifeGestionFinanciereOptions = [
  {
    value: 'GESTION_PAR_ADHERENT',
    label: 'Je souhaite gérer moi-même mon épargne',
    suffix: { title: 'A' },
  },
  {
    value: 'GESTION_DELEGUEE',
    label: 'Je souhaite déléguer la gestion de mon épargne',
    suffix: { title: 'B' },
  },
];
export const frequencyFinancialTransactionsOptions = [
  {
    value: 'MONTHLY',
    label: 'Mensuelle',
    suffix: { title: 'A' },
  },
  {
    value: 'QUARTERLY',
    label: 'Trimestrielle',
    suffix: { title: 'B' },
  },
  {
    value: 'BIANNUAL',
    label: 'Semestrielle',
    suffix: { title: 'C' },
  },
  {
    value: 'ANNUAL',
    label: 'Annuelle',
    suffix: { title: 'D' },
  },
  {
    value: 'GREATHER_THAN_ONE_YEAR',
    label: 'Supérieure à 1 an',
    suffix: { title: 'E' },
  },
];
export const perExitTypeOptions = [
  {
    value: 'RENTE',
    label: 'En rente',
    suffix: { title: 'A' },
  },
  {
    value: 'CAPITAL',
    label: 'En capital',
    suffix: { title: 'B' },
  },
];
export const investmentOptions = [
  {
    label: 'Versement initial',
    value: 'INITIAL',
    suffix: 'A',
    svg: 'money1.svg',
  },
  {
    label: 'Versement programmés',
    value: 'MONTHLY',
    suffix: 'B',
    svg: 'cashback1.svg',
  },
  {
    label: 'Initial + programmés',
    value: 'INITIAL_AND_MONTHLY',
    suffix: 'C',
    svg: 'cashback-group.svg',
  },
];
export const investmentOptionsWithoutProgrammed = [
  {
    label: 'Versement initial',
    value: 'INITIAL',
    suffix: 'A',
    svg: 'money1.svg',
  },
  {
    label: 'Initial + programmés',
    value: 'INITIAL_AND_MONTHLY',
    suffix: 'B',
    svg: 'cashback-group.svg',
  },
];
export const durationBeginInvestmentOption = [
  {
    value: 'LESS_THAN_FIVE_YEARS',
    label: 'Moins de 5 ans',
    suffix: { title: 'A' },
  },
  {
    value: 'FIVE_TEN_YEARS',
    label: '5 - 10 ans',
    suffix: { title: 'B' },
  },
  {
    value: 'TEN_FIFTEEN_YEARS',
    label: '10 - 15 ans',
    suffix: { title: 'C' },
  },
  {
    value: 'GREATHER_THAN_FIFTEEN',
    label: 'Plus de 15 ans',
    suffix: { title: 'D' },
  },
];
export const investmentHorizonOption = [
  {
    value: 'LESS_THAN_4_YEARS',
    label: 'Moins de 4 ans',
    suffix: { title: 'A' },
  },
  {
    value: 'BETWEEN_4_AND_8_YEARS',
    label: 'Entre 4 et 8 ans',
    suffix: { title: 'B' },
  },
  {
    value: 'BETWEEN_8_AND_12_YEARS',
    label: 'Entre 8 et 12 ans',
    suffix: { title: 'C' },
  },
  {
    value: 'MORE_THAN_12_YEARS',
    label: 'Plus de 12 ans',
    suffix: { title: 'D' },
  },
];
export const paymentFrequencyOptions = [
  {
    value: 'ANNUALLY_PAYMENT',
    label: 'Annuel',
  },
  {
    value: 'MONTHLY_PAYMENT',
    label: 'Mensuel',
  },
];
export const representativeFunctionOptions = [
  { value: 'CO_GERANT', label: 'Co-gérant' },
  { value: 'ASSOCIATE', label: 'Associé' },
  { value: 'DIRECTEUR_GENERAL', label: 'Directeur général' },
  { value: 'GERANT', label: 'Gérant' },
  { value: 'PRESIDENT', label: 'Président' },
];
export const realEstatePropertyTypeOptions = [
  {
    value: 'HOUSE',
    label: 'Maison',
    suffix: { title: 'A' },
  },
  {
    value: 'APPARTMENT',
    label: 'Appartement',
    suffix: { title: 'B' },
  },
];
export const realestateAgeTypeOptions = [
  {
    value: 'NEW',
    label: 'Neuf',
    suffix: { title: 'A' },
  },
  {
    value: 'OLD',
    label: 'Ancien',
    suffix: { title: 'B' },
  },
];

export const realEstateLocationDurationOptions = [
  {
    value: '6',
    label: '6 ans',
    suffix: { title: 'A' },
  },
  {
    value: '9',
    label: '9 ans',
    suffix: { title: 'B' },
  },
  {
    value: '12',
    label: '12 ans',
    suffix: { title: 'C' },
  },
];
export const realestateCategoryOptions = [
  {
    value: 'TOURISM',
    label: 'Résidence de Tourisme',
    suffix: { title: 'A' },
  },
  {
    value: 'EPHAD',
    label: 'EPHAD',
    suffix: { title: 'B' },
  },
  {
    value: 'STUDENT',
    label: 'Résidence étudiante',
    suffix: { title: 'C' },
  },
  {
    value: 'SENIOR',
    label: 'Résidence Sénior',
    suffix: { title: 'D' },
  },
  {
    value: 'BUSINESS',
    label: "Résidence d'affaire",
    suffix: { title: 'E' },
  },
  {
    value: 'COLOCATION',
    label: 'Colocation',
    suffix: { title: 'F' },
  },
  {
    value: 'AIRBNB',
    label: 'Airbnb',
    suffix: { title: 'G' },
  },
  {
    value: 'SHORT_STAY',
    label: 'Location sourt séjour',
    suffix: { title: 'H' },
  },
];
export const heldFinancialInstrumentsOptions = [
  {
    label: 'Aucun',
    value: 'AUCUN',
  },
  {
    label: 'Actions / OPCVM Action',
    value: 'ACTIONS',
  },
  {
    label: 'Obligations / OPCVM obligataires',
    value: 'OBLIGATAIRES',
  },
  {
    label: 'Placement de trésorerie / OPCVM monétaires',
    value: 'MONETAIRES',
  },
  {
    label: 'Produits structurés ou instruments financiers complexes',
    value: 'STRUCTURED_PRODUCTS',
  },
  {
    label: 'Immobilier indirect (SCPI, OPCI, ...)',
    value: 'INDIRECT_REAL_ESTATE',
  },
  {
    label: 'Autres',
    value: 'AUTRES',
  },
];
export const realEstateOwnershipTypeOptions: FormControlOption[] = [
  {
    value: 'PLEINE_PROPRIETE_CASH',
    label: 'En cash',
    suffix: 'A',
    svg: 'money1.svg',
  },
  {
    value: 'PLEINE_PROPRIETE_CREDIT',
    label: 'À crédit',
    suffix: 'B',
    svg: 'cashback1.svg',
  },
  {
    value: 'NU_PROPRIO',
    label: 'Nue-propriété',
    suffix: 'C',
    svg: 'money1.svg',
  },
];
export const averageAmountTransactionsOptions = [
  {
    value: 'LESS_THAN_5K',
    label: '< à 5K€',
    suffix: { title: 'A' },
  },
  {
    value: 'BETWEEN_5K_AND_20K',
    label: 'de 5K€ à 20K€',
    suffix: { title: 'B' },
  },

  {
    value: 'BETWEEN_20K_AND_50K',
    label: 'de 20K€ à 50K€',
    suffix: { title: 'C' },
  },

  {
    value: 'BETWEEN_50K_AND_100K',
    label: 'de 50K€ à 100K€',
    suffix: { title: 'D' },
  },
  {
    value: 'BETWEEN_100K_AND_300K',
    label: 'de 100K€ à 300K€',
    suffix: { title: 'E' },
  },

  {
    value: 'BETWEEN_300K_AND_500K',
    label: 'de 300K€ à 500K€',
    suffix: { title: 'F' },
  },

  {
    value: 'MORE_THAN_500K',
    label: 'Plus de 500K€',
    suffix: { title: 'G' },
  },
];
export const avProgammedPaymentTypeOptions = [
  {
    value: 'MONTHLY',
    label: 'Mensuel',
    suffix: { title: 'A' },
  },
  {
    value: 'QUARTERLY',
    label: 'Trimestriel',
    suffix: { title: 'B' },
  },
];

export const averageNumberTransactionsOptions = [
  {
    value: 'LESS_THAN_5',
    label: 'Moins de 5',
    suffix: { title: 'A' },
  },
  {
    value: 'BETWEEN_5_AND_10',
    label: 'Entre 5 et 10',
    suffix: { title: 'B' },
  },
  {
    value: 'BETWEEN_10_AND_15',
    label: 'Entre 10 et 15',
    suffix: { title: 'C' },
  },
  {
    value: 'MORE_THAN_15',
    label: 'Plus de 15',
    suffix: { title: 'D' },
  },
];

// new options
export const wealthDistributionOptions = [
  {
    label: 'Plus de 40% en actifs financiers',
    value: 'FINANCIAL_ASSETS',
  },

  {
    label: 'En liquidités',
    value: 'LIQUIDITY',
  },
  {
    label: 'En actifs professionnels',
    value: 'PROFESSIONAL_ASSETS',
  },
  {
    label: "Plus de 40% en immobilier d'investissement",
    value: 'REAL_ESTATE_INVESTMENT',
  },
  {
    label: 'En immobilier de jouissance',
    value: 'REAL_ESTATE_PERSONAL',
  },
];

export const profilEmprunteurDeplacementKilometriqueOptions = [
  {
    label: 'Aucun',
    value: 'AUCUN',
    suffix: { title: 'A' },
  },
  {
    label: 'Moins de 10 000km par an',
    value: 'V_0_10000',
    suffix: { title: 'B' },
  },
  {
    label: 'Entre 10 001 et 15 000km par an',
    value: 'V_10000_15000',
    suffix: { title: 'C' },
  },
  {
    label: 'Entre 15 001 et 20 000km par an',
    value: 'V_15000_20000',
    suffix: { title: 'D' },
  },
  {
    label: 'Entre 20 001 et 25 000km par an',
    value: 'V_20000_25000',
    suffix: { title: 'E' },
  },
  {
    label: 'Entre 25 001 et 30 000km par an',
    value: 'V_25000_30000',
    suffix: { title: 'F' },
  },
  {
    label: 'Entre 30 001 et 35 000km par an',
    value: 'V_30000_35000',
    suffix: { title: 'G' },
  },
  {
    label: 'Entre 35 001 et 40 000km par an',
    value: 'V_35000_40000',
    suffix: { title: 'H' },
  },
  {
    label: 'Plus de 40 000km par an',
    value: 'V_40000_PLUS',
    suffix: { title: 'I' },
  },
];

export const profilEmprunteurTravailEnHauteurOptions = [
  {
    label: 'Non',
    value: 'AUCUN',
    suffix: { title: 'A' },
  },
  {
    label: 'Entre 0 et 3 mètres',
    value: 'V_0_3',
    suffix: { title: 'B' },
  },
  {
    label: 'Entre 3 et 10 mètres',
    value: 'V_3_10',
    suffix: { title: 'C' },
  },
  {
    label: 'Entre 10 et 12 mètres',
    value: 'V_10_12',
    suffix: { title: 'D' },
  },
  {
    label: 'Entre 12 et 15 mètres',
    value: 'V_12_15',
    suffix: { title: 'E' },
  },
  {
    label: 'Entre 15 et 20 mètres',
    value: 'V_15_20',
    suffix: { title: 'F' },
  },
  {
    label: 'Plus de 20 mètres',
    value: 'V_20_PLUS',
    suffix: { title: 'G' },
  },
];

export const profilEmprunteurTravailARisqueOptions = [
  {
    label: 'Non',
    value: 'OCCUPATION_ATRISK_AUCUNE_PROF_A_RISQUE',
    suffix: { title: 'A' },
  },
  {
    label: 'Personnel navigant de compagnie aérienne régulière',
    value: 'OCCUPATION_ATRISK_AIR',
    suffix: { title: 'B' },
  },
  {
    label: "Artificier - Usage d'explosifs",
    value: 'OCCUPATION_ATRISK_ARTIFICIER',
    suffix: { title: 'C' },
  },
  {
    label:
      "Profession relative à l'art et au spectacle - à l'audiovisuel et information - au cirque (inclus journaliste et intermittent)",
    value: 'OCCUPATION_ATRISK_ARTISTIQUE_LITTERAIRE',
    suffix: { title: 'D' },
  },
  {
    label: 'Docker - Activité sur chantier naval',
    value: 'OCCUPATION_ATRISK_DOCKER',
    suffix: { title: 'E' },
  },
  {
    label: 'Métiers de l’industrie avec manipulation de produits dangereux',
    value: 'OCCUPATION_ATRISK_FABRICATION_TRANSPORT_MATIERES_DANGEREUSES',
    suffix: { title: 'F' },
  },
  {
    label: "Profession de surveillance sans port d'arme",
    value: 'OCCUPATION_ATRISK_GARDE_DU_CORPS',
    suffix: { title: 'G' },
  },
  {
    label: 'Profession de haute montagne (guide, moniteur de ski)',
    value: 'OCCUPATION_ATRISK_GUIDE_HAUTE_MONTAGNE',
    suffix: { title: 'H' },
  },
  {
    label: 'Secteur pétrolier (raffinage, exploitation, plate-forme)',
    value: 'OCCUPATION_ATRISK_INDUSTRIE_PETROLIERE',
    suffix: { title: 'I' },
  },
  {
    label: "Force de l'ordre",
    value: 'OCCUPATION_ATRISK_MAINTIEN_ORDRE',
    suffix: { title: 'J' },
  },
  {
    label: 'Armée (militaire, gendarme)',
    value: 'OCCUPATION_ATRISK_MILITAIRE',
    suffix: { title: 'K' },
  },
  {
    label: 'Activités humanitaires',
    value: 'OCCUPATION_ATRISK_MISSIONS_HUMANITAIRES',
    suffix: { title: 'L' },
  },
  {
    label:
      "Profession de la sécurité ou de la surveillance avec port d'arme - Douanier",
    value: 'OCCUPATION_ATRISK_PORT_MANIPULATION_ARMES',
    suffix: { title: 'M' },
  },
  {
    label: 'Pompier professionnel / sauveteur',
    value: 'OCCUPATION_ATRISK_SAPEUR_POMPIER',
    suffix: { title: 'N' },
  },
  {
    label: "Sportif professionnel - Entraîneur - Arbitre - Moniteur d'aviation",
    value: 'OCCUPATION_ATRISK_SPORTIF_PROFESSIONNEL',
    suffix: { title: 'O' },
  },
  {
    label: 'Maître nageur plage',
    value: 'OCCUPATION_ATRISK_MAITRE_NAGEUR',
    suffix: { title: 'P' },
  },
  {
    label: 'Personnel navigant de compagnie aérienne non régulière',
    value: 'OCCUPATION_ATRISK_AVIATION_HORS_LIGNES_REG',
    suffix: { title: 'Q' },
  },
  {
    label: 'Profession politique et personnel diplomatique',
    value: 'OCCUPATION_ATRISK_POLITIQUE_DIPLOMATE',
    suffix: { title: 'R' },
  },
  {
    label: 'Profession avec activité en mer',
    value: 'OCCUPATION_ATRISK_MER',
    suffix: { title: 'S' },
  },
  {
    label:
      'Travaux souterrains / mine / galerie / spéléologie / grande hauteur',
    value: 'OCCUPATION_ATRISK_SOUTERRAIN',
    suffix: { title: 'T' },
  },
  {
    label:
      "Profession relative à l'astrologie - Magnétisme - Cartomancie - Forain",
    value: 'OCCUPATION_ATRISK_FORAIN',
    suffix: { title: 'U' },
  },
  {
    label: 'Métiers du nucléaire',
    value: 'OCCUPATION_ATRISK_NUCLEAIRE',
    suffix: { title: 'V' },
  },
];

export const crowdfundingProjectTypeOptions = [
  {
    value: 'ACTIONS',
    label: 'Actions',
    suffix: { title: 'A' },
  },
  {
    value: 'OBLIGATIONS',
    label: 'Obligataires',
    suffix: { title: 'B' },
  },
];
export const productsType = {
  SCPI: 'SCPI',
  PER: 'PER',
  PINEL: 'PINEL',
  ASSURANCE_VIE: 'assurance vie',
  COMPTE_TITRE: 'Compte titre ordinaire',
  PEA: 'PEA',
  CONTRAT_CAPI: 'Contrat de capitalisation',
  PEI: 'PEI',
  PEE: 'PEE',
  PERCO: 'PERCO',
  FCPI: 'FCPI',
  FIP: 'FIP',
  FIP_DOMTOM: 'FIP_DOMTOM',
  FIP_CORSE: 'FIP_CORSE',
  FCPR: 'FCPR',
  FPS: 'FPS',
  GIRARDIN: 'GIRARDIN',
  INVESTISSEMENT_PME: 'INVESTISSEMENT PME',
  SOFICA: 'SOFICA',
  TANGIBLES: 'TANGIBLES',
  CROWDFUNDING: 'CROWDFUNDING',
  DEFISCALISATION: 'DEFISCALISATION',
  PRIVATE_EQUITY: 'Private Equity',
  LMNP: 'Immobilier meublé',
  UNFURNISHED: 'Immobilier non meublé',
  CAT: 'Compte à terme',
  BORROWER_INSURANCE: 'Assurance emprunteur',
};
export const URL_SIGNER =
  'https://preconys-domains-prod-documents.s3.eu-west-3.amazonaws.com/souscriptions/Attestation_SPIRACA_telephonique.pdf';
